import module from '@app/error/module'

module.config(($stateProvider) => {
  $stateProvider.state('nosoportado', {
    url: '',
    component: 'appErrorNosoportado',
    data: {title: 'Error'},
  })
})



// WEBPACK FOOTER //
// ./src/app/error/routes/nosoportado.js